import axios from './axiosService';

export default {
  getInvoices() {
    return axios.get(`/api/team/invoices`)
      .then(response => response.data);
  }
}
